import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import styled from "styled-components";
import { Drawer, Collapse } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FaEarthAmericas } from "react-icons/fa6";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
  Settings,
  Lock,
  DashboardOutlined,
  GavelOutlined,
  PeopleAltOutlined,
  LeakAdd,
  DeviceHub,
  Tune,
  NotificationImportant,
  ScatterPlot,
  DynamicFeed,
} from "@material-ui/icons";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";

import MenuIcon from "@material-ui/icons/Menu";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import smartParkService from "../axios";
import {
  hasLoaded_,
  login_,
  updatesessionid,
  usersessionid_,
  token_,
} from "../reducers/login";
import { sensors_, sensorServiceThunk } from "../reducers/sensors";
import { fields_, fieldsServiceThunk } from "../reducers/fields";
import {
  permissions_,
  Getaccesspermissions,
  hasLoadedpermissions_,
} from "../reducers/permissions";
import Manufacturer from "../views/Manufacturer/Manufacturer";
import { checkPermission } from "../utils/checkPermissions";

const drawerWidth = 215;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& .MuiDrawer-paper": {
      backgroundColor: "#03354b",
      color: "#fff",
    },
    "& .MuiListItem-gutters": {
      paddingLeft: "13px",
    },
    "& .MuiList-root": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: "-7px",
      },
    },
  },
  padL25: { paddingLeft: "25px" },
  padL35: { paddingLeft: "35px" },
  mainSidebar: {},
  collapseMenu: {
    marginLeft: "10px",
  },
  navBarMenu: {
    float: "right",
  },
  menuButton: {
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  menucloseButton: {
    marginRight: 36,
    justifyContent: "flex-end",
    color: "#fff",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(5) + 1,
    },
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(5) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  nested: {
    paddingLeft: theme.spacing(100),
  },
}));

const SBMList = styled(List)`
  .muicollapse-container: {
    padding-left: 37px;
  }
  .MuiListItem-root {
    border-left: 3px solid transparent;
    .MuiListItemIcon-root,
    .MuiListItemText-root {
      color: #fff;
    }
    .MuiListItemIcon-root {
      min-width: 40px;
      color: #fff;
    }
    .MuiListItemText-root {
      font-weight: bold;
    }
    &:hover,
    &:active {
      .MuiListItemIcon-root,
      .MuiListItemText-root {
        color: #5fd0ee;
      }
      border-left: 3px solid #5fd0ee;
    }
  }
`;
export default function MainSidebar({ sideBarOptions }) {
  const loginHasLoaded = useSelector(hasLoaded_);
  const permissionsloaded = useSelector(hasLoadedpermissions_);
  const loginDetails = useSelector(login_);
  const token = useSelector(token_);
  smartParkService.defaults.headers.common["x-access-token"] = token;
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [arrow, setarrow] = React.useState(true);
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [renderSidebar, setRenderSidebar] = useState(false);

  const navigateTo = ({ url }) => history.push(url);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [timeoutId, setTimeoutId] = React.useState(null);

  useEffect(() => {
    if (loginHasLoaded) {
      const rolearray = _.get(loginDetails, ["Role"], "");
      var keys = Object.keys(rolearray);
      var filtered = keys.filter(function (key) {
        return rolearray[key];
      });

      const parkid = _.get(loginDetails, ["parkID"], "");
      const userID = _.get(loginDetails, ["UserID"], "");
      parkid &&
        dispatch(
          Getaccesspermissions({ parkid, query: filtered.join(","), token })
        );
    }
  }, [loginHasLoaded]);

  useEffect(() => {
    if (permissionsloaded) {
      setRenderSidebar(true);
    }
  }, [permissionsloaded]);

  return (
    <div
      className={classes.root}
      onMouseEnter={() => {
        setarrow(true);
        // Set a new timeout
        const newTimeoutId = setTimeout(() => {
          setOpen(true);
        }, 1000);
        // Save the new timeoutId to the state
        setTimeoutId(newTimeoutId);
      }}
      onMouseLeave={() => {
        // Clear the timeout on mouse leave
        clearTimeout(timeoutId);
        setarrow(false);
        setSettingsOpen(false);
        setOpen(false);
      }}
    >
      {renderSidebar && (
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            <div className={classes.toolbar}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                className={clsx(classes.menuButton, {
                  [classes.hide]: open,
                })}
              >
                <MenuIcon />
              </IconButton>
              <IconButton
                onClick={handleDrawerClose}
                className={clsx(classes.menucloseButton, {
                  [classes.hide]: !open,
                })}
              >
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </div>
            <SBMList component="nav" aria-labelledby="sidebar-menu">
              {sideBarOptions.map((option, index) => {
                if (
                  checkPermission({
                    permission: option.permission,
                    permissionType: option.permissionType,
                  })
                ) {
                  return (
                    <ListItem
                      key={index}
                      button
                      onClick={() => {
                        navigateTo({ url: option.url });
                      }}
                      className="listmenusidebar"
                    >
                      <ListItemIcon>{option.icon}</ListItemIcon>
                      <ListItemText primary={option.name} disableTypography />
                    </ListItem>
                  );
                }
              })}
            </SBMList>
          </div>
        </Drawer>
      )}
    </div>
  );
}
